<div *ngIf="nodeTitle">
  <div class="note-notification">
    <span>Note:</span> Please provide the conditions for this filter. These conditions will be used to filter the data
    from the previous action. The composition determines what to do with this filtered data.
  </div>
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Action Title</mat-label>
      <input (ngModelChange)="handleNodeTitleChange('nodeTitle', $event)"
             [ngModel]="nodeTitle" matInput
             placeholder="Action Title"
             type="text">
    </mat-form-field>
  </div>
</div>

<form *ngIf="inputForm && isSupportedFiling == 'Yes'" (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-select formControlName="reportingCountryCode">
        <mat-option *ngFor="let country of reportingCountries" [value]="country.countryCode">
          {{country.displayText}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Filing Type</mat-label>
      <mat-select formControlName="filingType">
        <mat-option *ngFor="let filingType of filingTypes" [value]="filingType">
          {{filingType}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Version</mat-label>
      <mat-select formControlName="formTemplate" matTooltip="{{versionToolTip}}"
                  matTooltipClass="filing-version-custom-tooltip">
        <mat-option *ngFor="let formTemplate of associatedFormTemplates" [value]="formTemplate">
          {{formTemplate.version.substring(4)}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="selectedTemplate && selectedTemplate.category && selectedTemplate.category.length === 0">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Form Name</mat-label>
      <input matInput type="text" placeholder="Form Name" readonly value="{{selectedTemplate.displayText}}">
    </mat-form-field>
  </div>
  <div *ngIf="selectedTemplate && selectedTemplate.category && selectedTemplate.category.length > 0">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Category</mat-label>
      <mat-select formControlName="formCategory">
        <mat-option *ngFor="let category of selectedTemplate.category" [value]="category">
          {{category.title}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="selectedCategory && selectedCategory.subCategory">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Sub Category</mat-label>
      <mat-select formControlName="formSubCategory">
        <mat-option *ngFor="let subCategory of selectedCategory.subCategory" [value]="subCategory">
          {{subCategory.title}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="!formArrangement">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" type="text" placeholder="Title">
      <mat-error *ngIf="inputFormErrors.title.required">
        Title is required!
      </mat-error>
    </mat-form-field>
  </div>
  <div *ngIf="!formArrangement">
    <mat-form-field appearance="outline" class="orbitax-date-picker flex-0-0-405px">
      <mat-label>Select Due Date</mat-label>
      <input matInput formControlName="dueDate" [matDatepicker]="picker1" placeholder="Select Due Date"
             particleAnalytics
             analyticsCategory="date-time-cell"
             analyticsAction="date-picker">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
      <mat-error *ngIf="inputFormErrors.dueDate.required">
        Due Date is required!
      </mat-error>
    </mat-form-field>
  </div>
</form>
<div *ngIf="isSupportedFiling == 'No'">
  This form is not supported by Orbitax
</div>
